import { css } from '@emotion/react'
import { Heading, VFlow } from 'bold-ui'
import {
  AccordionDataTableRowDefault,
  AccordionDataTableRowDefaultProps,
} from 'components/accordion/accordion-data-table/AccordionDataTableRowDefault'
import { useMemo } from 'react'
import { EditableRow } from 'view/atendimentos/detail/components/EditableList'

import { convertRowModelToFormModel } from '../converter-orientacoes'
import { OrientacaoFormModel, OrientacaoRowModel } from '../model-orientacoes'
import { OrientacoesForm } from './OrientacoesForm'

interface OrientacoesTableRowProps extends AccordionDataTableRowDefaultProps<OrientacaoRowModel> {
  isEditing: boolean
  onUpdate(value: OrientacaoFormModel): void
  removeOrientacaoEmEdicao(): void
}

export function OrientacoesTableRow(props: Readonly<OrientacoesTableRowProps>) {
  const { row, isEditing, onUpdate, removeOrientacaoEmEdicao } = props

  const handleChange = (orientacao: OrientacaoFormModel) => {
    onUpdate(orientacao)
    removeOrientacaoEmEdicao()
  }

  const initialValues = useMemo(() => convertRowModelToFormModel(row), [row])

  return (
    <VFlow vSpacing={0}>
      <AccordionDataTableRowDefault {...props} />
      {isEditing && (
        <EditableRow editing={isEditing}>
          <Heading
            level={4}
            style={css`
              padding-top: 1rem;
            `}
          >
            Editar orientação
          </Heading>
          <OrientacoesForm
            onSubmit={handleChange}
            initialValues={initialValues}
            onCancel={removeOrientacaoEmEdicao}
            initialValuesEqual={(oldInitial, newInitial) => oldInitial.descricao === newInitial.descricao}
          />
        </EditableRow>
      )}
    </VFlow>
  )
}
